
import { motion } from 'framer-motion';

const targetGroups = [
  {
    name: 'Allgemeinmediziner',
    category: 'Hausärzte & Fachärzte',
    icon: 'ri-stethoscope-line',
    gradient: 'from-blue-100 to-blue-200',
    iconBg: 'bg-blue-500',
    description: 'Hausärzte und Fachärzte mit ganzheitlichem Behandlungsansatz, die Patienten zu Prävention und Nahrungsergänzung beraten'
  },
  {
    name: 'Physiotherapeuten',
    category: 'Bewegungstherapie',
    icon: 'ri-heart-pulse-line',
    gradient: 'from-purple-100 to-purple-200',
    iconBg: 'bg-purple-500',
    description: 'Therapeuten für Rehabilitation und Bewegungsoptimierung, die Patienten bei Gelenkgesundheit und Entzündungshemmung unterstützen'
  },
  {
    name: 'Ernährungsberater',
    category: 'Ernährungstherapie',
    icon: 'ri-restaurant-line',
    gradient: 'from-orange-100 to-orange-200',
    iconBg: 'bg-orange-500',
    description: 'Zertifizierte Ernährungsexperten, die individuelle Ernährungspläne erstellen und hochwertige Nahrungsergänzung empfehlen'
  },
  {
    name: 'Heilpraktiker',
    category: 'Naturheilkunde',
    icon: 'ri-leaf-line',
    gradient: 'from-emerald-100 to-emerald-200',
    iconBg: 'bg-emerald-500',
    description: 'Naturheilkundler mit Fokus auf ganzheitliche Gesundheit, die natürliche Supplements in ihre Behandlungskonzepte integrieren'
  }
];

export default function TargetGroups() {
  return (
    <section id="target-groups" className="py-24 bg-slate-50">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="mb-16">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-[56px] font-light text-slate-900 max-w-[40%] leading-tight"
          >
            Zielgruppen
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="text-lg text-slate-600 max-w-[500px] mt-4"
          >
            Finde automatisch die richtigen Gesundheitsprofis für dein Eqology Business – jede Zielgruppe mit spezifischem Fokus
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {targetGroups.map((group, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="group cursor-pointer"
            >
              <div className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 h-full">
                {/* Image Area */}
                <div className={`h-[240px] bg-gradient-to-br ${group.gradient} flex items-center justify-center relative overflow-hidden`}>
                  <motion.div
                    whileHover={{ scale: 1.1, rotate: 5 }}
                    transition={{ duration: 0.3 }}
                    className={`w-24 h-24 ${group.iconBg} rounded-full flex items-center justify-center shadow-2xl`}
                  >
                    <i className={`${group.icon} text-white text-5xl`}></i>
                  </motion.div>
                  
                  {/* Decorative circles */}
                  <div className="absolute top-4 right-4 w-16 h-16 bg-white/20 rounded-full"></div>
                  <div className="absolute bottom-4 left-4 w-12 h-12 bg-white/20 rounded-full"></div>
                </div>

                {/* Info Area */}
                <div className="p-6 space-y-4">
                  <div className="text-center">
                    <h3 className="text-2xl font-semibold text-slate-900 mb-2">
                      {group.name}
                    </h3>
                    <p className="text-sm text-slate-600 font-medium mb-3">
                      {group.category}
                    </p>
                  </div>

                  <p className="text-sm text-slate-600 text-center leading-relaxed px-2">
                    {group.description}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
